import om from "@/api/index";
import axios from "axios";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";

jest.mock("axios", () => {
  return {
    post: jest.fn(() => Promise.resolve({ data: {} })),
    get: jest.fn(() => Promise.resolve({ data: {} }))
  };
});

describe("index config", () => {
  beforeEach(() => {
    jest.clearAllMocks();
  });

  it("should send a POST request", async () => {
    const mockHash = { key: "value" };
    const mockResponse = { data: "data" };
    axios.post.mockResolvedValue(mockResponse);
    const request = {
      endPoint: "/some-request",
      body: mockHash
    };

    const result = await om.request(request);

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/some-request`,
      mockHash
    );
    expect(result).toEqual(mockResponse);
  });

  it("should send a GET sucursales", async () => {
    const payload = {
      latitud: "0.0000100",
      longitud: "0.0000200"
    };
    const mockResponse = { data: "data" };

    axios.get.mockResolvedValue(mockResponse);
    const result = await om.sucursales(payload);

    expect(axios.get).toHaveBeenCalledWith(
      `https://servicios.bbva.com.ar/openmarket/servicios/pois/v0/branches?latitude=0.0000100&longitude=0.0000200&radius=2500000&branchType=INTEGRAL`
    );
    expect(result).toEqual({ data: "data" });
  });

  it("should send a POST getResultVeridas", async () => {
    const key = "00001";
    const nroTramiteOferta = "101010";
    const consulta = {
      numeroDoc: "77778888",
      tipoDoc: "01",
      c: "ofertaNomina"
    };
    const deviceId = "ABC001";
    const deviceIdTimestamp = "01-01-2025T00:00:00";
    const numeroCliente = "1111111";
    const mockResponse = { data: "data" };

    axios.post.mockResolvedValue(mockResponse);
    const result = await om.getResultVeridas(
      key,
      nroTramiteOferta,
      consulta,
      deviceId,
      deviceIdTimestamp,
      numeroCliente
    );

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/vdigital/wp/getResult`,
      {
        key: "00001",
        numeroTramite: "101010",
        nroDoc: "77778888",
        c: "ofertaNomina",
        deviceId: "ABC001",
        deviceIdTimestamp: "01-01-2025T00:00:00",
        tipoDocumento: "01",
        numeroCliente: "1111111"
      }
    );
    expect(result).toEqual({ data: "data" });
  });

  it("should send a POST downloadContract", async () => {
    const payload = {};
    const mockResponse = { data: "data" };

    axios.post.mockResolvedValue(mockResponse);
    const result = await om.downloadContract(payload);

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/ventaTC/wp/descargarContratos`,
      {}
    );
    expect(result).toEqual({ data: "data" });
  });

  it("should send a POST crearUsuario", async () => {
    const payload = {};
    const mockResponse = { data: "data" };

    axios.post.mockResolvedValue(mockResponse);
    const result = await om.crearUsuario(payload);

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/ventaTC/wp/usuarioYClave`,
      {}
    );
    expect(result).toEqual({ data: "data" });
  });

  it("should send a POST validarRiesgoCliente", async () => {
    const payload = { dni: "11222333" };
    const mockResponse = { data: "data" };

    axios.post.mockResolvedValue(mockResponse);
    const result = await om.validarRiesgoCliente(payload);

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/ventaTC/wp/validarRiesgo`,
      payload
    );
    expect(result).toEqual({ data: "data" });
  });

  it("should send a POST acortarUrl", async () => {
    const url = "URL";
    const mockResponse = { data: "data" };
    axios.post.mockResolvedValue(mockResponse);

    const result = await om.acortarUrl(url);

    expect(axios.post).toHaveBeenCalledWith(`${API_BASE_SRC}/utils/sUrl`, {
      url
    });
    expect(result).toEqual(mockResponse);
  });
  it("should send a POST loginVeridas", async () => {
    const mockHash = {
      nroDoc: "11222333",
      c: "",
      deviceId: "deviceId",
      deviceIdTimestamp: "deviceIdTimestamp",
      tipoDocumento: "00",
      numeroCliente: "998877"
    };
    const mockResponse = { data: "data" };
    axios.post.mockResolvedValue(mockResponse);

    const result = await om.loginVeridas(
      {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: "11222333",
        nacionalidad: "80",
        sexo: "",
        fechaNacimiento: "",
        email: "",
        celular: {
          area: "",
          numero: "",
          normalizado: {
            area: "",
            caracteristica: "",
            nro: "",
            interno: "",
            valido: null
          },
          compania: ""
        },
        captcha: "",
        tipoResidencia: "",
        leadGenId: "",
        completed: false,
        hashref: ""
      },
      "deviceId",
      "deviceIdTimestamp",
      "998877"
    );

    expect(axios.post).toHaveBeenCalledWith(
      `${API_BASE_SRC}/vdigital/wp/login`,
      mockHash
    );
    expect(result).toEqual(mockResponse);
  });
});
